import React from "react";
import { IMG } from "../lib/data";

// Stylized minimalist Ariake mark — used only as a decorative motif for the Ariake project.
export const AriakeMark = ({ className = "h-7 w-7", color = "currentColor" }) => (
  <svg
    viewBox="0 0 64 64"
    className={className}
    aria-hidden="true"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16 28 A16 16 0 0 1 48 28" stroke={color} strokeWidth="4" strokeLinecap="square" />
    <rect x="12" y="38" width="40" height="4" fill={color} />
    <rect x="18" y="48" width="28" height="4" fill={color} />
  </svg>
);

// Official House & Home logo image (downloaded from the original site).
// `variant` controls whether it renders white (on dark bg) or black (on light bg).
export const HouseHomeLogo = ({ className = "", variant = "white" }) => (
  <img
    src={IMG.logoHH}
    alt="Inmobiliaria House & Home"
    className={`w-auto ${className || "h-11 md:h-12"}`}
    style={variant === "black" ? { filter: "invert(1) brightness(0)" } : undefined}
  />
);
